var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconMetaMask = function SvgIconMetaMask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33.13 4.821-11.79 8.756 2.181-5.166 9.61-3.59Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m5.914 4.821 11.694 8.84-2.073-5.25-9.621-3.59ZM28.889 25.118l-3.14 4.81 6.718 1.85 1.932-6.553-5.51-.107ZM4.67 25.225l1.919 6.552 6.718-1.848-3.14-4.81-5.498.106Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.928 16.99-1.872 2.832 6.671.296-.237-7.168-4.562 4.04ZM26.116 16.99l-4.621-4.123-.154 7.251L28 19.822l-1.884-2.832ZM13.308 29.929l4.005-1.955-3.46-2.702-.545 4.657ZM21.732 27.974l4.017 1.955-.557-4.657-3.46 2.702Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m25.749 29.929-4.017-1.955.32 2.618-.036 1.102 3.733-1.765ZM13.307 29.929l3.732 1.765-.023-1.102.296-2.618-4.005 1.955Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17.099 23.542-3.342-.983 2.358-1.079.984 2.062ZM21.945 23.542l.983-2.062 2.37 1.079-3.353.983Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m13.307 29.929.569-4.81-3.709.106 3.14 4.704ZM25.18 25.118l.568 4.81 3.14-4.703-3.708-.107ZM28 19.822l-6.66.296.616 3.424.984-2.061 2.37 1.078L28 19.822ZM13.757 22.559l2.37-1.078.972 2.061.628-3.424-6.671-.296 2.701 2.737Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m11.056 19.822 2.796 5.45-.095-2.713-2.701-2.737ZM25.31 22.559l-.119 2.713L28 19.822l-2.69 2.737ZM17.727 20.118l-.628 3.424.782 4.04.177-5.32-.331-2.144ZM21.34 20.118l-.32 2.133.143 5.332.794-4.04-.617-3.425Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.957 23.542-.794 4.04.569.392 3.46-2.702.118-2.713-3.353.983ZM13.757 22.559l.095 2.713 3.46 2.702.569-.392-.782-4.04-3.342-.983Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m22.016 31.694.036-1.102-.297-.26h-4.467l-.272.26.024 1.102-3.733-1.765 1.303 1.066 2.643 1.837h4.538l2.654-1.837 1.303-1.066-3.732 1.765Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m21.732 27.974-.57-.391h-3.281l-.57.39-.295 2.62.272-.261h4.467l.296.26-.32-2.618Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m33.628 14.146 1.007-4.834L33.13 4.82l-11.399 8.46 4.385 3.709 6.197 1.813 1.374-1.6-.592-.426.947-.865-.734-.57.948-.722-.628-.474ZM4.42 9.312l1.008 4.834-.64.474.948.723-.723.569.948.865-.593.426 1.363 1.6 6.197-1.813 4.384-3.709-11.399-8.46-1.493 4.49Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m32.313 18.803-6.197-1.813L28 19.822l-2.809 5.45 3.697-.047h5.51l-2.085-6.422ZM12.928 16.99l-6.197 1.813-2.062 6.422h5.498l3.685.047-2.796-5.45 1.872-2.832ZM21.34 20.118l.392-6.837 1.8-4.87h-7.997l1.777 4.87.415 6.837.142 2.156.012 5.309h3.282l.024-5.309.154-2.156Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgIconMetaMask;